import React, { useEffect } from 'react';
import { Row, Col, Image } from 'antd';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom'; // Using React Router for navigation
import { FaFacebook, FaTwitter, FaYoutube, FaInstagram, FaWhatsapp, FaAward, FaCertificate, FaComments, FaLightbulb, FaQuoteLeft } from 'react-icons/fa';
import myImage from '../assets/images/owner.webp';
import aboutImg from '../assets/images/about.webp';
import "../assets/css/about.css";

const About = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page-wrapper">
      {/* 1. Hero Section */}
      <section className="about-hero-section">
        <div className="container" style={{ display: 'block' }}>
          <Row className="align-items-center py-4">
            <Col xs={24} lg={14}>
              <div className="about-hero-content pe-lg-5">
                <h1 className="about-hero-title">Welcome to the Gramture Platform!</h1>
                <div className="title-separator"></div>
                <div className="gramture-desc">
                  <p>
                    Gramture is a revolutionary platform designed to make learning grammar and language structures simpler and more approachable. Whether you're a student, teacher, or lifelong learner, our platform offers a wide range of resources that aim to enhance your understanding of grammar in an easy-to-understand way.
                  </p>
                  <p>
                    Gramture, a blend of the words <span className="highlight">Grammar</span> and <span className="highlight">Structure</span>, symbolizes a modern approach to education. Our platform provides an enriching experience that simplifies grammar concepts and structures, enabling better communication skills for writing, speaking, and overall literacy.
                  </p>
                  <p>
                    At Gramture, we offer comprehensive study materials, practice exercises, and engaging tools to make learning grammar both educational and enjoyable. Our mission is to help learners of all levels gain confidence and proficiency in language.
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={24} lg={10} className='about-image-col'>
              <div className="about-image-wrapper" style={{ width: '100%', textAlign: 'center', marginTop: '40px' }}>
                <Image
                  src={aboutImg}
                  alt="About Gramture"
                  className="rounded-2"
                  style={{
                    borderRadius: '8px',
                    objectFit: 'cover',
                    maxWidth: '65%',
                    height: 'auto',
                  }}
                />
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* 2. CEO Section */}
      <section className="about-ceo-section">
        <div className="container" style={{ display: 'block' }}>
          <Row gutter={[40, 40]} className="align-items-center py-4">
            <Col xs={24} md={10} lg={8} className="ceo-profile-card-col">
              <div className="ceo-profile-card">
                <div className="ceo-image-wrapper">
                  <Image
                    width={200}
                    height={200}
                    src={myImage}
                    alt='Habib Ahmad Khan'
                    className="ceo-avatar"
                  />
                </div>
                <h4 className="ceo-name">Habib Ahmad Khan</h4>
                <p className="ceo-designation">Founder & CEO of Gramture</p>
                <p className="ceo-bio-brief">
                  At Gramture, we're redefining how grammar is taught, providing top-notch resources that revolutionize grammar education.
                </p>
                <div className="social-icons">
                  <a href="https://www.facebook.com/Gramture" target="_blank" rel="noreferrer" className="facebook"><FaFacebook /></a>
                  <a href="https://twitter.com/Gramture" target="_blank" rel="noreferrer" className="twitter"><FaTwitter /></a>
                  <a href="https://www.instagram.com/gramture/" target="_blank" rel="noreferrer" className="instagram"><FaInstagram /></a>
                  <a href="https://www.youtube.com/@gramture" target="_blank" rel="noreferrer" className="youtube"><FaYoutube /></a>
                  <a href="https://wa.me/+923036660025" target="_blank" rel="noreferrer" className="whatsapp"><FaWhatsapp /></a>
                </div>
              </div>
            </Col>

            <Col xs={24} md={14} lg={16}>
              <div className="ceo-message-box">
                <div className="ceo-quote-header">
                  <FaQuoteLeft className="ceo-quote-icon" />
                  <h3 className="ceo-quote-title">A Message from Our CEO</h3>
                </div>
                <p className='ceo-desc-text'>
                  "We’re not just another platform; Gramture is a movement. Our mission is to empower every learner with the tools they need to master grammar, develop communication skills, and build their confidence in using language effectively."
                </p>
                <p className="ceo-normal-text">
                  Through innovative learning methods, personalized study paths, and high-quality content, we are changing the way grammar is perceived and learned. We invite you to be part of this exciting journey.
                </p>
                <p className="ceo-normal-text">
                  At Gramture, we’re committed to turning grammar mastery into a lifelong advantage — empowering learners to express themselves with clarity, confidence, and impact.
                </p>
                <div className="ceo-signature-block">
                  <span className="ceo-signature-name">Habib Ahmad Khan</span>
                  <span className="ceo-signature-line">Founder & CEO, Gramture</span>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* 3. Feature Card Section */}
      <section className="about-features-section py-5">
        <div className="container" style={{ display: 'block' }}>
          <div className="features-header text-center mb-5">
            <span className="features-badge">EXCLUSIVE BENEFITS</span>
            <h2 className="section-title-main">Explore Our Exclusive Features</h2>
            <div className="features-underline"></div>
          </div>

          <Row gutter={[24, 24]} justify="center">
            {/* Card 1 */}
            <Col xs={24} sm={12} md={6}>
              <div className="feature-card">
                <div className="feature-icon-wrapper topper-notes-icon">
                  <FaAward />
                </div>
                <h5 className="card-title">Topper Choice Notes</h5>
                <p className="card-desc">Gain access to expertly curated notes used by top scorers to ensure you ace your exams with ease!</p>
                <div className="card-btn-wrapper">
                  <Link to="/" className="btn btn-primary feature-btn">Explore Now</Link>
                </div>
              </div>
            </Col>

            {/* Card 2 */}
            <Col xs={24} sm={12} md={6}>
              <div className="feature-card">
                <div className="feature-icon-wrapper board-tests-icon">
                  <FaCertificate />
                </div>
                <h5 className="card-title">Board Pattern Tests</h5>
                <p className="card-desc">Take board-patterned tests, get certified, and boost your readiness for upcoming exams!</p>
                <div className="card-btn-wrapper">
                  <Link to="/s" className="btn btn-primary feature-btn">Explore Now</Link>
                </div>
              </div>
            </Col>

            {/* Card 3 */}
            <Col xs={24} sm={12} md={6}>
              <div className="feature-card">
                <div className="feature-icon-wrapper discussion-icon">
                  <FaComments />
                </div>
                <h5 className="card-title">Discussion Forum</h5>
                <p className="card-desc">Join our interactive forum and engage with expert faculty to clear all your grammar-related doubts!</p>
                <div className="card-btn-wrapper">
                  <Link to="/discussion_forum" className="btn btn-primary feature-btn">Join Now</Link>
                </div>
              </div>
            </Col>

            {/* Card 4 */}
            <Col xs={24} sm={12} md={6}>
              <div className="feature-card">
                <div className="feature-icon-wrapper expert-tips-icon">
                  <FaLightbulb />
                </div>
                <h5 className="card-title">Expert Tips</h5>
                <p className="card-desc">Learn time-tested strategies to secure the highest marks across all subjects and exams.</p>
                <div className="card-btn-wrapper">
                  <Link to="/" className="btn btn-primary feature-btn">Explore Now</Link>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default About;
